import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _Object$values from 'babel-runtime/core-js/object/values';
import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { KEYCODES } from './helpers';

import { selectDropdown, selectDropdownAbove, selectDropdownBelow } from './SelectDropdown.style';

var SUPPORTED_KEYCODES = _Object$values(KEYCODES);
var MIN_SPACE = 200;
var DEFAULT_HEIGHT = 350;
var MARGIN = 30;
var PLACEMENT = {
  ABOVE: 'spaceAbove',
  BELOW: 'spaceBelow'
};

var calculateFreeSpace = function calculateFreeSpace(parentBox) {
  var _ref;

  var documentElement = document.documentElement || {};
  var viewportHeight = Math.max(documentElement.clientHeight, window.innerHeight || 0);

  return _ref = {}, _defineProperty(_ref, PLACEMENT.ABOVE, parentBox.top), _defineProperty(_ref, PLACEMENT.BELOW, viewportHeight - parentBox.bottom), _ref;
};

var choosePlacement = function choosePlacement(space) {
  if (space[PLACEMENT.BELOW] > MIN_SPACE || space[PLACEMENT.ABOVE] <= MIN_SPACE) {
    return PLACEMENT.BELOW;
  }
  return PLACEMENT.ABOVE;
};

var calculatePosition = function calculatePosition(parentBox, placement) {
  var _verticalHook;

  var documentElement = document.documentElement || {};
  var scroll = {
    x: window.pageXOffset || documentElement.scrollLeft || 0,
    y: window.pageYOffset || documentElement.scrollTop || 0
  };
  var verticalHook = (_verticalHook = {}, _defineProperty(_verticalHook, PLACEMENT.ABOVE, parentBox.top), _defineProperty(_verticalHook, PLACEMENT.BELOW, parentBox.bottom), _verticalHook);
  return {
    left: Math.round(parentBox.left + scroll.x),
    top: Math.round(verticalHook[placement] + scroll.y)
  };
};

var calculateDimensions = function calculateDimensions(node, parentBox, availableSpace) {
  var dropdownContentHeight = node instanceof HTMLElement ? node.scrollHeight : DEFAULT_HEIGHT;
  var height = Math.min(dropdownContentHeight + MARGIN, availableSpace - MARGIN);
  return {
    height: height,
    width: parentBox.width
  };
};

var createConfigObject = function createConfigObject(parent, node) {
  var _verticalBase;

  if (!node) {
    return {
      placement: PLACEMENT.BELOW,
      styles: {
        position: 'fixed',
        opacity: 0
      }
    };
  }

  var parentBox = parent.getBoundingClientRect();
  var space = calculateFreeSpace(parentBox);
  var placement = choosePlacement(space);
  var pos = calculatePosition(parentBox, placement);
  var dim = calculateDimensions(node, parentBox, space[placement]);

  var verticalBase = (_verticalBase = {}, _defineProperty(_verticalBase, PLACEMENT.ABOVE, { bottom: 'calc(100% - ' + pos.top + 'px)', top: 'auto' }), _defineProperty(_verticalBase, PLACEMENT.BELOW, { top: pos.top + 'px', bottom: 'auto' }), _verticalBase);
  return {
    placement: placement,
    styles: _extends({
      'max-height': dim.height + 'px',
      width: dim.width + 'px',
      position: 'absolute',
      opacity: 1,
      left: pos.left + 'px'
    }, verticalBase[placement])
  };
};

var SelectDropdown = function (_Component) {
  _inherits(SelectDropdown, _Component);

  function SelectDropdown() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SelectDropdown.__proto__ || _Object$getPrototypeOf(SelectDropdown)).call.apply(_ref2, [this].concat(args))), _this), _this.getEventListenersArgs = function () {
      return [['resize', _this.updateStyle], ['mousedown', _this.handleOutsideMouseClick, { capture: true }], ['touchstart', _this.handleOutsideMouseClick, { capture: true, passive: false }], ['keydown', _this.handleKeydown, { capture: true }], ['wheel', _this.handleOutsideMouseClick]];
    }, _this.storeDropdownRef = function (node) {
      _this.dropdownNode = node;
    }, _this.handleKeydown = function (e) {
      if (SUPPORTED_KEYCODES.indexOf(e.keyCode) === -1) return;

      e.preventDefault();

      switch (e.keyCode) {
        case KEYCODES.ESCAPE:
          _this.props.onCloseRequest(e);
          break;
        case KEYCODES.ARROW_DOWN:
        case KEYCODES.ARROW_RIGHT:
          _this.props.onFocusNextRequest(e);
          break;
        case KEYCODES.ARROW_UP:
        case KEYCODES.ARROW_LEFT:
          _this.props.onFocusPrevRequest(e);
          break;
        default:
          break;
      }
    }, _this.handleOutsideMouseClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = e.target;

      if (_this.dropdownNode.contains(target)) return;
      _this.props.onCloseRequest(e);
    }, _this.handleMouseWheel = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var wheelDelta = e.wheelDelta,
          detail = e.detail,
          deltaY = e.deltaY;

      var delta = Number(wheelDelta || detail || -deltaY);
      _this.dropdownNode.scrollTop -= delta;
    }, _this.updateStyle = function () {
      if (!_this.dropdownNode) return;

      var _createConfigObject = createConfigObject(_this.props.parent, _this.dropdownNode),
          placement = _createConfigObject.placement,
          styles = _createConfigObject.styles;

      _this.dropdownNode.className = _this.classNames(placement, _this.props.theme);
      _Object$keys(styles).forEach(function (key) {
        _this.dropdownNode.style.setProperty(key, styles[key]);
      });
    }, _this.classNames = function (placement, theme) {
      var _cx;

      return cx(selectDropdown(theme), (_cx = {}, _defineProperty(_cx, selectDropdownAbove, placement === PLACEMENT.ABOVE), _defineProperty(_cx, selectDropdownBelow, placement === PLACEMENT.BELOW), _cx), _this.props.className);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getEventListenersArgs().forEach(function (args) {
        var _window;

        return (_window = window).addEventListener.apply(_window, _toConsumableArray(args));
      });
      setTimeout(function () {
        _this2.updateStyle();
        if (_this2.props.onShow) _this2.props.onShow();
      }, 0);
      this.dropdownNode.addEventListener('wheel', this.handleMouseWheel);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.getEventListenersArgs().forEach(function (args) {
        var _window2;

        return (_window2 = window).removeEventListener.apply(_window2, _toConsumableArray(args));
      });
      this.dropdownNode.removeEventListener('wheel', this.handleMouseWheel);
    }

    /* eslint-disable complexity */

    /* eslint-enable complexity */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          theme = _props.theme,
          zIndex = _props.zIndex;

      var classNames = this.classNames(PLACEMENT.BELOW, theme);

      return React.createElement(
        'div',
        { className: classNames, ref: this.storeDropdownRef, style: { zIndex: zIndex } },
        children
      );
    }
  }]);

  return SelectDropdown;
}(Component);

SelectDropdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  parent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onCloseRequest: PropTypes.func.isRequired,
  onFocusNextRequest: PropTypes.func.isRequired,
  onFocusPrevRequest: PropTypes.func.isRequired,
  onShow: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'dark']).isRequired,
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default SelectDropdown;